module.exports = __webpack_public_path__ + "img/patent2.9fb9b216.jpg";